var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 591,
    height: 564,
    viewBox: "0 0 591 564",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M471.906 87.9992C528.233 129.353 583.134 177.837 589.551 232.025C595.968 286.213 553.901 346.818 514.686 402.432C474.758 458.046 438.395 508.669 385.633 537.189C332.871 565.709 263.71 571.413 199.54 553.588C135.37 535.05 76.1911 492.27 40.5411 434.517C4.89113 376.764 -6.51688 302.612 3.46512 231.312C14.1601 159.299 46.2451 89.4252 99.0071 48.0712C152.482 6.71718 227.347 -6.11682 292.943 3.86518C358.539 14.5602 416.292 47.3582 471.906 87.9992Z",
    fill: "url(#paint0_linear_13_67)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_67",
    x1: 0.00683594,
    y1: 563.755,
    x2: 562.494,
    y2: -25.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F87537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA81F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlub);
export default __webpack_public_path__ + "static/media/blub.1c677bc1932196683df8cd085af7237b.svg";
export { ForwardRef as ReactComponent };